import React from 'react';
import { Typography, Chip, Box, Stack } from '@mui/material';
import type { JourneyItem } from '@/client/models/journey-item';
import type { JourneyInfo } from '@/services/journeyService';
import type { Disruption } from '@/client/models/disruption';
import JourneyTableRow from './JourneyTableRow';

interface JourneyTableProps {
    journeys: JourneyItem[];
    getJourneyInfo: (journey: JourneyItem) => JourneyInfo;
    getJourneyDisruptions: (journey: JourneyItem, journeyInfo: JourneyInfo) => Disruption[];
    generateTripId: (journey: JourneyItem, journeyInfo: JourneyInfo) => string;
    onDetailClick: (journey: JourneyItem, journeyInfo: JourneyInfo, journeyDisruptions: Disruption[], tripId: string) => void;
}

const JourneyTable: React.FC<JourneyTableProps> = ({
    journeys,
    getJourneyInfo,
    getJourneyDisruptions,
    generateTripId,
    onDetailClick,
}) => {
    return (
        <Box sx={{ width: '100%' }}>
            <Typography variant="h6" sx={{ p: 2, pb: 1, display: 'flex', alignItems: 'center' }}>
                Trains disponibles <Chip label={journeys.length} color="primary" size="small" sx={{ ml: 1 }} />
            </Typography>
            <Stack spacing={1} sx={{ width: '100%', pb: 2 }}>
                {journeys.map((journey, index) => {
                    const journeyInfo = getJourneyInfo(journey);
                    const journeyDisruptions = getJourneyDisruptions(journey, journeyInfo);
                    const tripId = generateTripId(journey, journeyInfo);

                    return (
                        <JourneyTableRow
                            key={index}
                            journey={journey}
                            journeyInfo={journeyInfo}
                            journeyDisruptions={journeyDisruptions}
                            tripId={tripId}
                            onDetailClick={() => onDetailClick(journey, journeyInfo, journeyDisruptions, tripId)}
                        />
                    );
                })}
            </Stack>
        </Box>
    );
};

export default JourneyTable;
